<template>
  <div class="mb-8 w-full">
    <div class="flex items-center">
      <p class="text-dark-blue">
        {{ subject }}
      </p>
      <slot />
    </div>
    <p class="mb-1 text-xxs font-bold uppercase text-gray-over-dark">
      {{ question.description }}
    </p>
    <div class="mt-4 grid grid-cols-2 gap-2">
      <div
        v-for="option in orderedOptions"
        :key="option"
        class="mb-2 w-full md:mb-0"
      >
        <round-radio-button
          custom-class="text-xs sm:text-sm"
          :item="option.value"
          :value="option.id"
          :name="'radio_' + question_id"
          :checked="option.id === selection"
          :handle-click="handleClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import RoundRadioButton from '@/components/RoundRadioButton.vue';
import _ from 'lodash';

export default {
  name: 'Radio',
  components: {
    RoundRadioButton,
  },
  props: {
    question: Object,
    question_id: Number,
    subject: String,
    setOnboardingPacket: Function,
    toggleRequired: Function,
    required: Boolean,
    conditional_children: Array,
  },
  emits: ['child-check'],
  data() {
    return {
      selection: '',
    };
  },
  computed: {
    orderedOptions() {
      return _.orderBy(this.question.options, 'order');
    },
    stepName() {
      return this.$store.state.formRoutes?.activeStepIdentifier;
    },
  },
  // created() {
  //   let recentAnswer = this.question?.most_recent_previous_answer;
  //   if (recentAnswer) {
  //     this.selection = recentAnswer.answer_options[0].option_id;
  //     this.handleAutoInput();
  //   }
  // },
  watch: {
    '$store.state.onboardingPacket.current_stage': {
      handler: function (val) {
        let self = this;
        if (val == 7 && self.selection !== '') {
          self.emitForComparison(self.selection);
        }
      },
      immediate: true,
      deep: true,
    },
    stepName: {
      handler(newVal) {
        if (newVal == 'Questions') {
          let recentAnswer = this.question?.most_recent_previous_answer;
          if (recentAnswer) {
            this.selection = recentAnswer.answer_options[0].option_id;
            this.handleAutoInput();
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClick(e) {
      this.selection = parseInt(e.target.value);
      let body = {
        company_question_id: this.question_id,
        answer_options_attributes: [{ option_id: this.selection }],
      };

      this.setOnboardingPacket(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    handleAutoInput() {
      let body = null;
      if (this.selection) {
        body = {
          company_question_id: this.question_id,
          answer_options_attributes: [{ option_id: this.selection }],
        };
      }

      this.setOnboardingPacket(body);
      if (this.required) {
        this.selection
          ? this.toggleRequired(this.question_id, true)
          : this.toggleRequired(this.question_id, false);
      }
      this.emitForComparison(this.selection);
    },
    emitForComparison(value) {
      if (this.conditional_children?.length > 0) {
        this.conditional_children.forEach((child) => {
          if (
            child?.evaluation_js?.length > 0 &&
            child?.company_question_id > 0
          ) {
            this.$emit(
              'child-check',
              child.company_question_id,
              value,
              child.evaluation_js,
              child.is_shown_by_default,
              child.is_required
            );
          }
        });
      }
    },
  },
};
</script>
